module.exports = {
  // Local server
  // baseUrl: "http://localhost:4000/api/v1",
  // Local server
  // Official server
  baseUrl: "https://juscatering.onrender.com/api/v1",
  // Official server
};
